import { Button } from '~/components/Buttons'
import Tooltip from '~/components/Tooltip'
import i18n from '~/i18n'

import { actions, actionsByEntity, entities } from '../../lib/constants'
import { fieldNamesByEntity } from '../../lib/fieldNamesByEntity'

type RequestTitleProps = {
  data: AuditLogItemChange & AuditLogItemChangeDetail
}

type TransformFieldName = (fieldName: string) => ResponseGetAuditLogFieldNames

const RequestTitle: React.FC<RequestTitleProps> = ({ data }) => {
  const { entity, action, user_name, user_email, field_name, origin } = data

  const buttonText = entities[entity]
  const buttonTemplates: {
    [key in ResponseGetAuditLogEntities]: ButtonTemplates
  } = {
    ad: 'primary',
    campaign: 'primary',
    campaign_keyword: 'info',
    campaign_subpublisher: 'info',
    campaign_category: 'info',
    campaign_checking_account: 'primary',
    campaign_destination_url: 'primary',
    network_publishers_campaigns_status: 'primary'
  }
  const buttonTemplate = buttonTemplates[entity]

  const actionText =
    actionsByEntity?.[entity]?.[action] || actions?.[action] || action

  const transformFieldName: TransformFieldName = fieldName => {
    if (fieldName.includes('settings.destinations')) {
      return 'settings.destinations'
    }

    if (
      fieldName === 'destination_urls' ||
      fieldName.startsWith('destination_urls.')
    ) {
      return 'destination_urls'
    }

    return fieldName as ResponseGetAuditLogFieldNames
  }

  const fieldName = fieldNamesByEntity({
    entity: entity,
    action: action,
    fieldName: transformFieldName(field_name)
  })

  return (
    <div>
      <Button
        as="span"
        text={buttonText}
        template={buttonTemplate}
        size="xsmall"
        customWidth="5rem"
        style={{ padding: '0 .5rem', cursor: 'initial' }}
      />{' '}
      <Tooltip
        icon={<strong className="userName">{user_name}</strong>}
        text={user_email}
        positionProp="center-top"
      />{' '}
      <span className="action" style={{ fontWeight: 'normal' }}>
        {actionText}
      </span>{' '}
      <strong className="fieldName">{fieldName}</strong>
      {origin === 'AGENT' && (
        <>
          {' via '}
          <strong>{i18n.t('rm:Tools.CampaignManager')}</strong>
        </>
      )}
    </div>
  )
}

export default RequestTitle
